import { useContext } from 'react';
import { reactKeycloakWebContext } from './context';
export function useKeycloak() {
    var _a = useContext(reactKeycloakWebContext), initialized = _a.initialized, authClient = _a.authClient;
    return {
        initialized: initialized,
        keycloak: authClient,
    };
}
//# sourceMappingURL=useKeycloak.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-keycloak/web/lib/useKeycloak.js
// module id = 426
// module chunks = 0